export enum CertificateFormat {
  FoldOver = 1,
  Card = 2,
}